const API_URL = "/api";

const getToken = () => localStorage.getItem("portfolio_token");

const apiFetch = async (method, path, body) => {
  const token = getToken();
  const headers = {};
  if (token) {
    headers["Authorization"] = "Bearer " + token;
  }
  
  // Check if body is FormData (for file uploads)
  const isFormData = body instanceof FormData;
  
  let requestBody;
  if (isFormData) {
    // For FormData, don't set Content-Type header - let the browser handle it
    // This ensures proper multipart/form-data encoding
    console.log(`[API ${method}] ${path}`, "[FormData object with multipart content]");
    requestBody = body;
  } else {
    // For regular JSON payloads
    headers["Content-Type"] = "application/json";
    console.log(`[API ${method}] ${path}`, body);
    requestBody = body ? JSON.stringify(body) : undefined;
  }
  
  const url = API_URL + path;
  
  try {
    const res = await fetch(url, {
      method,
      headers,
      body: requestBody
    });
    
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `API error: ${res.status}`);
    }
    
    const data = await res.json();
    // Ensure we never return undefined - return empty array or object as fallback
    return data ?? [];
  } catch (error) {
    console.error(`[API ERROR] ${method} ${url}:`, error);
    throw error;
  }
};

export const api = {
  get: (path) => apiFetch("GET", path),
  post: (path, data) => apiFetch("POST", path, data),
  put: (path, data) => apiFetch("PUT", path, data),
  delete: (path) => apiFetch("DELETE", path),
};

export const mapRows = (res) =>
  Array.isArray(res)
    ? res.map((row) => ({
        id: row.id,
        ...(typeof row.data === "string" ? JSON.parse(row.data) : row.data || row),
      }))
    : [];

export const mapRow = (res) =>
  res ? { id: res.id, ...(res.data || res) } : null;

export default api;
